import { apiClient } from "../config";

async function deleteATag(id: any) {
  const url = `/admin/tags/${id}`;
  const res = await apiClient.delete(url);
  return res.data;
}

export default deleteATag;
